import React from 'react';
import { Mail, Phone, Clock, MapPin } from 'lucide-react';
import { MagneticButton } from '../components/animated/MagneticButton';
export function ContactPage() {
  const handleCalendlyClick = () => {
    window.open('https://calendly.com/precious-ajoonu', '_blank');
  };
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-742">
      <main className="flex-grow pt-32" data-id="element-743">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-50 to-white py-16" data-id="element-744">
          <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-745">
            <div className="max-w-4xl mx-auto text-center" data-id="element-746">
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-6" data-id="element-747">
                We'd Love to Hear From You
              </h1>
              <p className="text-xl text-gray-600 mb-8" data-id="element-748">
                Whether you have questions about our consulting services, need
                help upskilling your team, or just want to learn more about
                SkillzHQ, our team is here to assist you.
              </p>
              <MagneticButton variant="primary" size="lg" onClick={handleCalendlyClick} data-id="element-749">
                Book a Discovery Call
              </MagneticButton>
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section className="py-16 bg-white" data-id="element-750">
          <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-751">
            <div className="max-w-4xl mx-auto" data-id="element-752">
              <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-753">
                Get in Touch
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-754">
                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-755">
                  <div className="flex items-center mb-4" data-id="element-756">
                    <Mail className="h-6 w-6 text-blue-600 mr-3" data-id="element-757" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-758">Email</h3>
                  </div>
                  <a href="mailto:support@myskillzhq.com" className="text-blue-600 hover:text-blue-700" data-id="element-759">
                    support@myskillzhq.com
                  </a>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-760">
                  <div className="flex items-center mb-4" data-id="element-761">
                    <Phone className="h-6 w-6 text-blue-600 mr-3" data-id="element-762" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-763">Phone</h3>
                  </div>
                  <a href="tel:+2348106836707" className="text-blue-600 hover:text-blue-700" data-id="element-764">
                    0810 683 6707
                  </a>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-765">
                  <div className="flex items-center mb-4" data-id="element-766">
                    <Clock className="h-6 w-6 text-blue-600 mr-3" data-id="element-767" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-768">
                      Office Hours
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-769">
                    Monday - Friday
                    <br data-id="element-770" />
                    8:00 AM - 5:00 PM
                  </p>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-771">
                  <div className="flex items-center mb-4" data-id="element-772">
                    <MapPin className="h-6 w-6 text-blue-600 mr-3" data-id="element-773" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-774">Address</h3>
                  </div>
                  <p className="text-gray-700" data-id="element-775">
                    SkillzHQ Headquarters
                    <br data-id="element-776" />
                    Jeydens Court, Agungi, Lagos
                  </p>
                </div>
              </div>

              {/* CTA Section */}
              <div className="bg-gradient-to-br from-blue-600 to-green-600 p-8 rounded-2xl text-center" data-id="element-777">
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-778">
                  Ready to Transform Your Organization?
                </h3>
                <p className="text-blue-100 mb-6" data-id="element-779">
                  Schedule a 30-minute discovery call with our team to discuss
                  your needs and explore how we can help.
                </p>
                <MagneticButton variant="secondary" size="lg" onClick={handleCalendlyClick} data-id="element-780">
                  Book a Discovery Call
                </MagneticButton>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>;
}